import { render, staticRenderFns } from "./company.vue?vue&type=template&id=71155c97&scoped=true&lang=pug&"
var script = {}
import style0 from "./company.vue?vue&type=style&index=0&id=71155c97&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71155c97",
  null
  
)

export default component.exports